import { commonConstants } from './constants/commonConstants';


export const getService = (data:any) => ({
  type: commonConstants.getServiceRequest,
  payload: data
}); 


export const getServiceParams = (data: any) => ({
  type: commonConstants.getServiceParamsRequest,
  payload: data,
});

const clearMessage = () => ({
  type: commonConstants.clearMessage as any
});

const getServiceView = (data: any) => ({
  type: commonConstants.serviceViewRequest,
  payload: data,
});

const createService = (data: any) => ({
  type: commonConstants.createServiceRequest,
  payload: data,
});

const serviceToggle = (data: any) => ({
  type: commonConstants.serviceToggleRequest,
  payload: data,
});

const deleteService = (data: any) => ({
  type: commonConstants.deleteServiceRequest,
  payload: data,
});

const deleteFiles = (data: any) => ({
  type: commonConstants.fileDeleteRequest,
  payload: data,
});

const sendMail = (data: any) => ({
  type: commonConstants.contactEmailRequest,
  payload: data,
});

export const commonActions = {
  clearMessage,
  getServiceParams,
  getService,
  serviceToggle,
  createService,
  deleteService,
  deleteFiles,
  sendMail,
  getServiceView,
};

